import { usePipelinesQuery } from './usePipelinesQuery';
import { usePipelinesSearch } from './usePipelinesSearch';

export const usePipelines = (filters: Record<string, string> = {}) => {
    const query = usePipelinesQuery(filters);
    const { keyword } = usePipelinesSearch();

    const items = query.data?.pages?.flatMap(page =>
        (page && 'items' in page) ? page.items : []
    ) ?? [];

    const visibleItems = items.filter(item =>
        !keyword ||
        item.name?.toLowerCase().includes(keyword.toLowerCase()) ||
        item.description?.toLowerCase().includes(keyword.toLowerCase()) ||
        item.codeRepositoryName?.toLowerCase().includes(keyword.toLowerCase())
    );

    const fetchNextPage = () => {
        if (query.hasNextPage) {
            query.fetchNextPage();
        }
    };

    return {
        items,
        visibleItems,
        loading: query.isLoading,
        nextToken: query.hasNextPage ? 'has-more' : null,
        fetchNextPage,
    };
};
